import { render, staticRenderFns } from "./_goodsSpu.vue?vue&type=template&id=75ffaabd&"
import script from "./_goodsSpu.vue?vue&type=script&lang=js&"
export * from "./_goodsSpu.vue?vue&type=script&lang=js&"
import style0 from "./_goodsSpu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports